<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="teams"
                  :items-per-page="500"
                  :footer-props="{'items-per-page-options': [5, 10, 25, 50, 100, 500]}"
                  :loading="loading"
                  loading-text="Loading teams...">
      <template v-slot:item.name="{item: team}">
        <strong v-if="team.id === user.current_team_id">
          {{ team.name }} (CURRENT)
        </strong>
        <template v-else>
          {{ team.name }}
        </template>
      </template>
      <template v-slot:item.created_at="{item: team}">
        {{ team.created_at | datetime('MMM D, YYYY @ h:mm a') }}
      </template>

      <template v-slot:item.status="{item: team}">
        {{ team.status }}
      </template>

      <template v-slot:item.pivot="{item: team}">
        <change-team-role :team="team"
                          :user="user"
                          v-if="isSuperAdmin"
                          @updated="$emit('updated')">
        </change-team-role>
        <template v-else>
          {{ team.pivot.role_name }}
        </template>
      </template>

      <template v-slot:item.actions="{item: team}">
        <v-btn small
               @click.prevent="switchToTeam(team)"
               :disabled="!team.is_active || team.id === user.current_team_id">
          Switch
        </v-btn>
        <v-btn color="error"
               small
               @click.prevent="removeFromTeam(team)"
               :disabled="!team.is_active || user.teams.length === 1 || user.current_team_id === team.id">
          Remove
        </v-btn>
      </template>
    </v-data-table>

  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import oauthService from '../../../../../ml/services/oauthService';
import ChangeTeamRole from './ChangeTeamRole';
import userService from '../../../services/userService';
import {Form} from 'vform';
import DOMPurify from 'dompurify';

export default {
  components: {ChangeTeamRole},
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    teams: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({}),
      headers: [
        {text: 'Team', value: 'name', filterable: true,},
        {text: 'Status', value: 'status', filterable: false,},
        {text: 'Role on team', value: 'pivot', filterable: false,},
        {text: 'Actions', value: 'actions', filterable: false, sortable: false,},
      ],
      team: null,
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'isSuperAdmin',
    ]),
  },
  methods: {
    closeDialog() {
      this.team = null;
    },
    removeFromTeam(team) {
      if (!confirm(`Are you sure you want to remove ${DOMPurify.sanitize(this.user.name)} from ${DOMPurify.sanitize(team.name)}?`)) {
        return;
      }
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      userService.removeUserFromTeam(this.user.id, team.id)
        .then(() => {
          this.$toast.success(`${DOMPurify.sanitize(this.user.name)} removed from ${DOMPurify.sanitize(team.name)}`);
          this.$emit('updated');
        })
        .finally(() => {
          this.form.busy = false;
        })
    },
    switchToTeam(team) {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      userService.switchUserToTeam(this.user.id, team.id)
        .then(() => {
          this.$toast.success(`${DOMPurify.sanitize(this.user.name)} switched to ${DOMPurify.sanitize(team.name)}`);
          this.$emit('updated');
        })
        .finally(() => {
          this.form.busy = false;
        })
    }
  }
}
</script>
